module.exports = __webpack_public_path__ + "static/images/ad.119e31f.png";